<template>
  <section class="section">
    <div class="section-body">
      <div class="card">
        <div class="card-header" style="padding: 0 0 0 15px !important">
          <h4>
            <!-- {{ $t("messages.home.yearCalendar") }} -->
            {{ appInfo.data.ENROLL_ACADYEAR_SEMESTER_TEXT }}
          </h4>
        </div>
        <div class="card-body">
          <div class="container" style="padding: 0 !important">
            <v-card class="mx-auto" tile>
              <v-menu
                v-model="selectedOpen"
                :close-on-content-click="false"
                :activator="selectedElement"
                offset-x
              >
                <v-card color="grey lighten-4" min-width="350px" flat>
                  <v-toolbar :color="selectedEvent.colorType" dark>
                    <v-toolbar-title
                      :style="getEventColorTitle(selectedEvent.dateType)"
                      v-html="selectedEvent.title"
                    ></v-toolbar-title>
                    <div class="flex-grow-1"></div>
                  </v-toolbar>
                  <v-card-text
                    v-for="(item, index) in selectedEvent.details"
                    :key="index"
                  >
                    <span v-html="item">{{ item }}</span>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text color="secondary" @click="selectedOpen = false">
                      {{ $t("messages.general.close") }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
              <v-container v-if="!isNotStaff">
                <v-row>
                  <v-col cols="8">
                    <div class="information-block">
                      <div class="row">
                        <div class="col no-padding-bottom">
                          <div class="information-detail">
                            <div class="col no-margin-padding">
                              <div>{{ $t("messages.home.totalStudent") }}</div>
                            </div>
                            <div
                              class="col no-margin-padding text-right"
                              style="flex: 0 0 10em;"
                            >
                              <div>{{ stat.STUDENT_ALL }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col no-padding-bottom">
                          <div class="information-detail">
                            <div class="col no-margin-padding">
                              <div>{{ $t("messages.home.reqStudent") }}</div>
                            </div>
                            <div
                              class="col no-margin-padding text-right"
                              style="flex: 0 0 10em;"
                            >
                              <div>{{ stat.STUDENT_ENROLL }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col no-padding-bottom">
                          <div class="information-detail">
                            <div class="col no-margin-padding">
                              <div>{{ $t("messages.home.preReqStudent") }}</div>
                            </div>
                            <div
                              class="col no-margin-padding text-right"
                              style="flex: 0 0 10em;"
                            >
                              <div>{{ stat.STUDENT_PREREG }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col no-padding-bottom">
                          <div class="information-detail">
                            <div class="col no-margin-padding">
                              <div>
                                {{ $t("messages.home.preReqLessNine") }}
                              </div>
                            </div>
                            <div
                              class="col no-margin-padding text-right"
                              style="flex: 0 0 10em;"
                            >
                              <div>{{ stat.STUDENT_PREREG_LESS_THAN_9 }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col no-padding-bottom">
                          <div class="information-detail">
                            <div class="col no-margin-padding">
                              <div>
                                {{ $t("messages.home.notPreReqStudent") }}
                              </div>
                            </div>
                            <div
                              class="col no-margin-padding text-right"
                              style="flex: 0 0 10em;"
                            >
                              <div>{{ stat.STUDENT_UNSUCCESS_PREREG }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
              <v-container v-if="isNotStaff">
                <button
                  type="button"
                  class="btn btn-primary btn-lg"
                  @click="handleShowCalender()"
                  v-if="!isShowCalendar"
                >
                  {{ $t("messages.general.showCalender") }}
                </button>
              </v-container>
              <swiper v-if="isShowCalendar">
                <v-container>
                  <v-row class="fill-height">
                    <v-col
                      :class="[
                        currentMonth1 == tempCurMonth
                          ? 'borderRed'
                          : 'borderWhite'
                      ]"
                    >
                      <v-sheet height="64">
                        <v-toolbar flat color="white">
                          <v-menu bottom right>
                            <template v-slot:activator="{ on }">
                              <v-toolbar-title
                                style="width: 100%; text-align: center"
                                >{{ monthTxt1 }}</v-toolbar-title
                              >
                            </template>
                          </v-menu>
                        </v-toolbar>
                      </v-sheet>
                      <v-sheet id="div-calendar">
                        <v-calendar
                          ref="calendar1"
                          v-model="focus1"
                          :type="type"
                          :locale="locale"
                          :color="color"
                          :event-color="getEventColor"
                          :event-text-color="getEventColorText"
                          :dark="dark"
                          :light="light"
                          :events="events"
                          @click:event="showEvent"
                          @click:date="viewDay1"
                          :event-more="eventMore"
                        />
                      </v-sheet>
                    </v-col>
                    <v-col
                      :class="[
                        currentMonth2 == tempCurMonth
                          ? 'borderRed'
                          : 'borderWhite'
                      ]"
                    >
                      <v-sheet height="64">
                        <v-toolbar flat color="white">
                          <v-menu bottom right>
                            <template v-slot:activator="{ on }">
                              <v-toolbar-title
                                style="width: 100%; text-align: center"
                                >{{ monthTxt2 }}</v-toolbar-title
                              >
                            </template>
                          </v-menu>
                        </v-toolbar>
                      </v-sheet>
                      <v-sheet id="div-calendar">
                        <v-calendar
                          ref="calendar2"
                          v-model="focus2"
                          :type="type"
                          :locale="locale"
                          :color="color"
                          :event-color="getEventColor"
                          :event-text-color="getEventColorText"
                          :dark="dark"
                          :light="light"
                          :events="events"
                          @click:event="showEvent"
                          @click:date="viewDay2"
                          :event-more="eventMore"
                        />
                      </v-sheet>
                    </v-col>
                    <v-col
                      :class="[
                        currentMonth3 == tempCurMonth
                          ? 'borderRed'
                          : 'borderWhite'
                      ]"
                    >
                      <v-sheet height="64">
                        <v-toolbar flat color="white">
                          <v-menu bottom right>
                            <template v-slot:activator="{ on }">
                              <v-toolbar-title
                                style="width: 100%; text-align: center"
                                >{{ monthTxt3 }}</v-toolbar-title
                              >
                            </template>
                          </v-menu>
                        </v-toolbar>
                      </v-sheet>
                      <v-sheet id="div-calendar">
                        <v-calendar
                          ref="calendar3"
                          v-model="focus3"
                          :type="type"
                          :locale="locale"
                          :color="color"
                          :event-color="getEventColor"
                          :event-text-color="getEventColorText"
                          :dark="dark"
                          :light="light"
                          :events="events"
                          @click:event="showEvent"
                          @click:date="viewDay3"
                          :event-more="eventMore"
                        />
                      </v-sheet>
                    </v-col>
                  </v-row>
                </v-container>
                <div
                  class="swiper-button-prev"
                  slot="button-prev"
                  @click="handlePrev"
                ></div>
                <div
                  class="swiper-button-next"
                  slot="button-next"
                  @click="handleNext"
                ></div>
              </swiper>
            </v-card>
            <br />
            <p
              class="title"
              style="padding: 0 0 0 15px !important; color: #000;"
            >
              {{ $t("messages.general.listItem") }}
            </p>
            <v-card
              class="mx-auto"
              tile
              style="max-height: 300px; overflow: auto"
            >
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        {{ $t("messages.general.activity") }}
                      </th>
                      <th class="text-left">
                        {{ $t("messages.general.date") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in eventList" :key="i">
                      <td>{{ item.title }}</td>
                      <td>{{ listDetail(item) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import "moment/locale/th";
import { swiper } from "vue-awesome-swiper";
import UserProvider from "@/services/user_provider";
import EnrollProvider from "@/services/enroll_provider";

import "swiper/dist/css/swiper.css";

const userProvider = new UserProvider();
const enrollProvider = new EnrollProvider();

export default {
  name: "home",
  components: {
    swiper
  },
  data: () => ({
    type: "month",
    locale: "th",
    color: "pink",
    dark: false,
    light: false,
    today: "",
    prev: "",
    current: "",
    currentText: "",
    next: "",
    currentMonth1: "",
    currentMonth2: "",
    currentMonth3: "",
    tempCurMonth: "",
    focus1: "",
    focus2: "",
    focus3: "",
    monthTxt1: "",
    monthTxt2: "",
    monthTxt3: "",
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    swiperOption: {
      centeredSlides: true,
      initialSlide: 4,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    },
    calendarEventCurrent: [],
    calendarEvent: [],
    events: [],
    eventList: [],
    stat: {},
    isShowCalendar: false,
    eventMore: false
  }),
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      getReload: "getReload",
      appMenus: "getMenu",
      studentInfo: "getStudentInfo"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
    currentMenu: function() {
      return this.appInfo.currentMenu;
    },
    currentyear: function() {
      return this.currentLang == "th"
        ? parseInt(moment().format("YYYY")) + 543
        : moment().format("YYYY");
    },
    isNotStaff: function() {
      return (
        this.appInfo.data.USER_TYPE == "S" || this.appInfo.data.USER_TYPE == "A"
      );
    },
    isLoginAs: function() {
      return !_.isEmpty(this.studentInfo.data);
    }
  },
  async mounted() {
    const tReload = this.getReload;
    console.log("getReload home mount", tReload);
    if (!Number.isInteger(tReload)) {
      const dt = new Date();
      const dtReload = new Date(tReload);
      var diff = (dt.getTime() - dtReload.getTime()) / 1000;
      diff /= 60;
      const dtDiff = Math.abs(Math.round(diff));
      if (dtDiff > 1) {
        return;
      }
    } else {
      if (tReload == -1) {
        return;
      }
    }
    console.log("home reload");
    this.tokenHealthChk();
    this.switchTheme(0);
    this.setCurrentMenu({
      mainMenu: {
        th: this.$t("messages.home.mainPage", "th"),
        en: this.$t("messages.home.mainPage", "en")
      },
      menu: {
        id: 0,
        th: this.$t("messages.home.currentInfo", "th"),
        en: this.$t("messages.home.currentInfo", "en")
      }
    });
    this.today = moment().format("YYYY-MM-DD");
    const curr = new Date();
    this.tempCurMonth = `${curr.getMonth()}${this.getYearTxt(curr)}`;
    this.isShowCalendar = false;
    this.initCalendar(this.today, false);

    // Fix Relocation to register when has menu
    if (this.isLoginAs) {
      let gotoMenuName = "home1";
      if (this.appMenus && this.appMenus.length > 0) {
        let menuStudent = this.appMenus.filter(x =>
          x.MENU_NAMEENG.toLowerCase().includes("student")
        );
        if (menuStudent) {
          if (
            menuStudent[0].Children.some(x =>
              x.MENU_NAVIGATIONURL_NEW.toLowerCase().includes("/register")
            )
          ) {
            gotoMenuName = "register";
          }
        }
      }
      this.$router.push({ name: gotoMenuName });
    }
  },
  methods: {
    ...mapActions("application", [
      "togglePreLoader",
      "setCurrentMenu",
      "switchTheme",
      "tokenHealthChk"
    ]),
    initCalendar(d, isTemp) {
      if (d != null) {
        this.currentText = d;
        this.current = new Date(new Date(d).setDate(1));
      }

      this.prev = this.subtractMonth(this.current, 1);
      this.focus1 = moment(this.prev).format("YYYY-MM-DD");
      this.monthTxt1 = `${this.getMonthText(
        this.prev.getMonth() + 1
      )} ${this.getYearTxt(this.prev)}`;
      this.currentMonth1 = `${this.prev.getMonth()}${this.getYearTxt(
        this.prev
      )}`;

      this.focus2 = moment(this.current).format("YYYY-MM-DD");
      this.monthTxt2 = `${this.getMonthText(
        this.current.getMonth() + 1
      )} ${this.getYearTxt(this.current)}`;
      this.currentMonth2 = `${this.current.getMonth()}${this.getYearTxt(
        this.current
      )}`;

      this.next = this.addMonth(this.current, 1);
      this.focus3 = moment(this.next).format("YYYY-MM-DD");
      this.monthTxt3 = `${this.getMonthText(
        this.next.getMonth() + 1
      )} ${this.getYearTxt(this.next)}`;
      this.currentMonth3 = `${this.next.getMonth()}${this.getYearTxt(
        this.next
      )}`;
      this.locale = this.currentLang;
      this.loadData(isTemp);
    },
    checkInRange(dt) {
      const d = new Date(dt);
      const dNext = new Date(this.next);
      const nextEnd = moment(dNext)
        .endOf("month")
        .add(1, "days")
        .format("YYYY-MM-DD");
      const range = moment(d).isBetween(this.prev, nextEnd);
      if (range) {
        return true;
      }
      return false;
    },
    initEventData(data, isTemp) {
      if (data == undefined) return;
      this.events = [];
      if (!isTemp) {
        this.eventList = [];
        this.calendarEventCurrent = [];
      }
      for (let idx = 0; idx < data.length; idx++) {
        const d = data[idx];
        const startDateTime = moment(d.DATEFROM).format("YYYY-MM-DD HH:mm");
        const endDateTime = moment(d.DATETO).format("YYYY-MM-DD HH:mm");
        const tmpEvent = {
          title: d.SCHEDULECODENAME,
          details: d.SCHEDULECODENAME,
          name: d.SCHEDULECODENAME,
          start: startDateTime,
          end: endDateTime,
          color: d.ISCURRENTDATE == "Y" ? "red darken-4" : "blue accent-1",
          icon: "mdi-clock",
          datetxt: d.DATE_TEXT
        };
        if (!isTemp) {
          this.eventList.push(tmpEvent);
        }
        if (this.isShowCalendar) {
          if (endDateTime !== undefined) {
            const daysDiff = this.dateDiff(
              moment(d.DATEFROM),
              moment(d.DATETO)
            );
            const isCurrent = d.ISCURRENTDATE == "Y";
            const date = this.$t("messages.general.date");
            for (let i = 0; i < daysDiff; i++) {
              const tmpDate = this.addDays(moment(d.DATEFROM), i);
              if (!this.checkInRange(tmpDate)) continue;
              const startDate = moment(tmpDate).format("DD/MM");
              const found = this.events.find(f => {
                return (
                  moment(f.start).format("YYYY-MM-DD") ==
                    moment(tmpDate).format("YYYY-MM-DD") &&
                  f.isCurrent == isCurrent
                );
              });
              if (found) {
                found.details.push(
                  `${d.SCHEDULECODENAME}<br/>${this.listDetail(tmpEvent)}`
                );
              } else {
                const tmp = {
                  title: `${date} ${startDate}/${this.getCurrentyear(tmpDate)}`,
                  details: [],
                  name: "...",
                  start: moment(tmpDate).format("YYYY-MM-DD"),
                  color:
                    d.ISCURRENTDATE == "Y" ? "red darken-4" : "blue accent-1",
                  colorType: this.getColorByType(d.PERIODTYPE),
                  dateType: d.PERIODTYPE,
                  icon: "mdi-clock",
                  isCurrent: d.ISCURRENTDATE == "Y"
                };
                tmp.details.push(
                  `${d.SCHEDULECODENAME}<br/>${this.listDetail(tmpEvent)}`
                );
                this.events.push(tmp);
              }
            }
          }
        }
        if (d.ISCURRENTDATE == "Y" && !isTemp) {
          this.calendarEventCurrent.push(idx);
        }
      }
      // console.log('this.eventList', this.eventList);
      // console.log('this.events', this.events);
    },
    getColorByType(type) {
      let result = "";
      switch (type) {
        case 1:
          result = "#0bbbec";
          break;
        case 2:
          result = "#00FF99";
          break;
        case 3:
          result = "#FFFF99";
          break;
        case 4:
          result = "#b71c1c";
          break;
      }
      return result;
    },
    getEventColor(event) {
      return event.colorType;
    },
    getEventColorTitle(type) {
      return type == 4 ? "color: #fff" : "color: #000";
    },
    getEventColorText(event) {
      return event.dateType == 4 ? "#fff !important" : "#000 !important";
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };
      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },
    getCurrentyear: function(d) {
      return this.currentLang == "th"
        ? parseInt(moment(d).format("YYYY")) + 543
        : moment(d).format("YYYY");
    },
    listDetail(event) {
      const startDate = moment(event.start).format("DD/MM");
      const endDate = moment(event.end).format("DD/MM");
      const startTime = moment(event.start).format("HH:mm");
      const endTime = moment(event.end).format("HH:mm");
      let result = "";
      const date = this.$t("messages.general.date");
      const time = this.$t("messages.general.time");
      const to = this.$t("messages.general.to");
      if (event.start == event.end) {
        result = ` ${startDate}/${this.getCurrentyear(event.start)}`;
      } else {
        if (startDate == endDate) {
          result = `${date} ${startDate}/${this.getCurrentyear(
            event.start
          )} ${time} ${startTime} ${to} ${endTime}`;
        } else {
          if (startTime == endTime) {
            result = `${date} ${startDate}/${this.getCurrentyear(
              event.start
            )} ${to} ${endDate}/${this.getCurrentyear(event.end)}`;
          } else {
            result = `${date} ${startDate}/${this.getCurrentyear(
              event.start
            )} ${time} ${startTime} ${to} ${endDate}/${this.getCurrentyear(
              event.end
            )} ${time} ${endTime}`;
          }
        }
      }
      return result;
      // return event.datetxt;
    },
    dateDiff(d1, d2) {
      const date1 = new Date(d1);
      const date2 = new Date(d2);
      const diffTime = Math.abs(date2 - date1);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    },
    addDays(d, days) {
      var date = new Date(d);
      date.setDate(date.getDate() + days);
      return date;
    },
    subtractMonth(dt, numberOfMonths) {
      var d = new Date(dt);
      d.setMonth(d.getMonth() - numberOfMonths);
      d.setDate(1);
      return d;
    },
    addMonth(dt, numberOfMonths) {
      var d = new Date(dt);
      d.setMonth(d.getMonth() + numberOfMonths);
      d.setDate(1);
      return d;
    },
    getMonthText(n) {
      let result = "";
      switch (n) {
        case 1:
          result = this.$t("messages.general.month.january");
          break;
        case 2:
          result = this.$t("messages.general.month.february");
          break;
        case 3:
          result = this.$t("messages.general.month.march");
          break;
        case 4:
          result = this.$t("messages.general.month.april");
          break;
        case 5:
          result = this.$t("messages.general.month.may");
          break;
        case 6:
          result = this.$t("messages.general.month.june");
          break;
        case 7:
          result = this.$t("messages.general.month.july");
          break;
        case 8:
          result = this.$t("messages.general.month.august");
          break;
        case 9:
          result = this.$t("messages.general.month.september");
          break;
        case 10:
          result = this.$t("messages.general.month.october");
          break;
        case 11:
          result = this.$t("messages.general.month.november");
          break;
        case 12:
          result = this.$t("messages.general.month.december");
          break;
      }
      return result;
    },
    getYearTxt(d) {
      const dt = new Date(d);
      return this.currentLang == "th"
        ? parseInt(moment(dt).format("YYYY")) + 543
        : moment(dt).format("YYYY");
    },
    async loadData(isTemp) {
      this.togglePreLoader(true);
      const { data } = this.appInfo;
      if (!isTemp) {
        const param = {
          token: this.token,
          request: {
            acadyear: data.CURRENT_ACADYEAR,
            currentsemester: data.CURRENT_SEMESTER,
            schedulegroupid: data.SCHEDULEGROUPID,
            usertype: data.USER_TYPE,
            lang: this.currentLang
          }
        };
        if (this.appInfo.data.USER_TYPE == "S") {
          param.request["studentid"] = this.userId;
        }
        this.calendarEvent = await userProvider.currentCalendar(param);
        if (this.calendarEvent) {
          this.calendarEvent.forEach(c => {
            c.DATEFROM = c.DATEFROM.replace("GMT", "GMT+7");
            c.DATETO = c.DATETO.replace("GMT", "GMT+7");
          });
        }
        console.log("calendarEvent", this.calendarEvent);
      }
      this.initEventData(this.calendarEvent, isTemp);
      this.initStat();
      this.togglePreLoader(false);
    },
    handlePrev() {
      this.initCalendar(this.prev, true);
    },
    handleNext() {
      this.initCalendar(this.next, true);
    },
    async initStat() {
      console.log("home load stat 0", this.isNotStaff);
      if (!this.isNotStaff) {
        const params = {
          token: this.token,
          request: {
            acadyear: this.appInfo.data.ENROLL_ACADYEAR,
            semester: this.appInfo.data.ENROLL_SEMESTER
          }
        };
        const result = await enrollProvider.getEnrollStat(params);
        if (result.length > 0) {
          this.stat = result[0];
        }
      }
    },
    viewDay1() {
      const month = parseInt(moment(this.prev).format("M"));
      const tempMonth = parseInt(moment(this.focus1).format("M"));
      if (month !== tempMonth) {
        this.focus1 = moment(this.prev).format("YYYY-MM-DD");
      }
    },
    viewDay2() {
      const month = parseInt(moment(this.current).format("M"));
      const tempMonth = parseInt(moment(this.focus2).format("M"));
      if (month !== tempMonth) {
        this.focus2 = moment(this.current).format("YYYY-MM-DD");
      }
    },
    viewDay3() {
      const month = parseInt(moment(this.next).format("M"));
      const tempMonth = parseInt(moment(this.focus3).format("M"));
      if (month !== tempMonth) {
        this.focus3 = moment(this.next).format("YYYY-MM-DD");
      }
    },
    handleShowCalender() {
      this.isShowCalendar = true;
      this.loadData(false);
    }
  },
  watch: {
    currentLang() {
      this.initCalendar(this.currentText, false);
    }
  }
};
</script>

<style scoped>
.borderRed {
  border: 3px pink dotted;
}
.borderWhite {
  border: 3px transparent dotted;
}
.swiper-button-prev,
.swiper-button-next {
  top: 12% !important;
  width: 50px !important;
  height: 30px !important;
  background-size: 50px 100px;
}
.card-body {
  padding: 0 !important;
}
</style>
